import RepresentativeAdvancedView from './RepresentativeAdvancedView'

export default RepresentativeAdvancedView
